/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Team_Native_TitleInputs */

const en_mk_team_native_title = /** @type {(inputs: Mk_Team_Native_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use your agent subscription`)
};

const id_mk_team_native_title = /** @type {(inputs: Mk_Team_Native_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pakai langganan agent`)
};

/**
* | output |
* | --- |
* | "Use your agent subscription" |
*
* @param {Mk_Team_Native_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_team_native_title = /** @type {((inputs?: Mk_Team_Native_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Team_Native_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_team_native_title(inputs)
	return en_mk_team_native_title(inputs)
});